import type { ReactNode } from "react";
import { cx } from "../cx";
/** Timeline de versiones del banco (sk-vtimeline). */
export function VTimeline({ children }: { children: ReactNode }) {
  return <div className="sk-vtimeline">{children}</div>;
}
export function VersionCard({ v, state, s, d, dimmed }: { v: ReactNode; state: "pub" | "draft" | "ghost"; s?: ReactNode | undefined; d?: ReactNode | undefined; dimmed?: boolean | undefined }) {
  return (
    <div className={cx("sk-ver", `sk-ver--${state}`)} style={dimmed ? { opacity: 0.4 } : undefined}>
      <div className="sk-ver-v">{v}</div>
      {s !== undefined && <div className="sk-ver-s">{s}</div>}
      {d !== undefined && <div className="sk-ver-d">{d}</div>}
    </div>
  );
}
